<template>
    <main class="pd-main">
        <div class="main-content">
            <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
            <div v-else>
                <div class="row" >
                    <div class="col-12">
                        <div class="card">
                            <h4 class="card-title">
                            <strong>ALL TRAININGS</strong>
                            </h4>
                            <div class="card-body">
                            <v-client-table :columns="columns" :data="data" :options="options"> 
                                <div slot="id" slot-scope="props" >{{props.index}}</div>                          
                                <div slot="actions" slot-scope="props">
                                    <nav class="flexbox justify-content-start fs-16">
                                        <!-- Add has_test condition -- :disabled="props.row.has_test == true" -->
                                        <circle-spin v-if="indexClicked==props.index" disabled class="btn btn-xs btn-round btn-primary"></circle-spin>
                                        <button v-else :disabled="props.row.has_test == true" class="btn btn-xs btn-round btn-primary" @click="newTest(props.row, props.index)">
                                            Add Test
                                        </button>
                                        
                                        <router-link :to="`/admin/trainings/${props.row.id}`" class="btn btn-xs btn-round btn-secondary" >
                                            View
                                        </router-link>
                                        <router-link :to="`/admin/trainings/${props.row.id}/edit`" class="btn btn-xs btn-round btn-primary" >
                                            Edit
                                        </router-link>
                                        <a href="#" @click="delAction(props.row)" data-provide="tooltip" data-original-title="Delete">
                                            <span class="btn btn-xs btn-danger">Delete</span>
                                        </a>
                                    </nav>
                                </div>                          
                            </v-client-table>             
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8">
                        <component 
                        :is="mode" 
                        @addNew="openNewTrainingForm" 
                        :training_title="training_title"
                        :training_id="training_id"></component>
                    </div>
                </div>
            </div>

          <!-- Modal for delete -->
            <modal name="delete-action" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                    <div class="callout callout-error py-10 px-0 mb-0" role="alert">
                        <span class="close mr-10" @click="hideDeleteModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                        <h5 class="text-capitalize">Delete Training</h5>
                        <div class="p-10">
                            <p>Are you sure you want to delete this training?</p>
                            <button class="btn btn-bold btn-sm btn-danger" disabled v-if="load_delete">
                                <circle-spin class="m-0"></circle-spin>
                            </button>
                            <button class="btn btn-bold btn-sm btn-danger" v-else type="button" @click="deleteAction">Delete</button>
                        </div>
                    </div>
                </div> 
            </modal>   
        </div>
    </main>
</template>

<script>
import axios from "axios";
import Default from "../../components/admin/default.vue"
import newTest from "../../components/admin/addTest.vue"
import newTraining from "../../components/admin/addTraining.vue"

export default {
  data() {
    return {
      firstLoad: true,
      mode: "default",
      columns: ["id", "title", 'actions'],
      data: [],
      options: {
        headings: {
          id: "S/N",
          title: "Title",
          actions: "Actions"
        },
        sortable: ["title"],
        filterable: ["title"]
      },
    load_delete: false,
    id: null,
      training_title: "",
      training_id: null,
      indexClicked: null,
      test_load: false,
      test_id: null,
      has_test: null
    };
  },
  methods: {
    newTest(payload, index) {
            this.training_id = payload.id
            this.training_title = payload.title
            this.mode = 'new-test'
        
    },
    openNewTrainingForm() {
        this.mode = "new-training"
    },
    delAction(payload) {
          this.id = payload.id
          if(payload.has_test == true){
            this.test_id = payload.tests[0].id
          }
          this.$modal.show("delete-action");
        },
        hideDeleteModal(a) {
            a.hide('delete-action')
        },
        deleteAction() {
            this.load_delete = true
            if(this.test_id == null){
                axios.delete(`/admin/delete?type=training&id=${this.id}`)
                .then(res => {
                        this.load_delete = false
                            this.$notify({
                                group: 'response',
                                type: 'success',
                                text: 'Successfully deleted.',
                                duration: 2500,
                            })
                            setTimeout(() => {
                                location.reload()
                            }, 3000)
                })
                .catch(err => {
                        this.load_delete= false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000,
                        });
                })
            }
            else{
                axios.delete(`/admin/delete?type=test&id=${this.test_id}`)
                .then(res => {
                    axios.delete(`/admin/delete?type=training&id=${this.id}`)
                    .then(res => {
                        this.load_delete = false
                            this.$notify({
                                group: 'response',
                                type: 'success',
                                text: 'Successfully deleted.',
                                duration: 2500,
                            })
                            setTimeout(() => {
                                location.reload()
                            }, 3000)
                    })
                    .catch(err => {
                        this.load_delete= false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000,
                        });
                    })
                })
                .catch(err => {
                        this.load_delete= false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000,
                        });
                })
            }
        }
  },
  mounted() {
    axios.get("/admin/list?type=training")
    .then(res => {
      this.firstLoad = false;
      return (this.data = res.data.data);
    })
    .catch(err => {
            this.firstLoad = false;
            this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
            });
        })
  },
  components: {
      Default,
      newTest,
      newTraining
  }
};
</script>
